import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-arrow-long-right-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      d: "M11.724 4.583a.625.625 0 01.884 0l2.975 2.975a.625.625 0 010 .884l-2.975 2.975a.625.625 0 11-.884-.883l1.908-1.909H.86a.625.625 0 110-1.25h12.773l-1.908-1.909a.625.625 0 010-.883z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const ArrowLongRightIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
ArrowLongRightIcon.displayName = 'ArrowLongRightIcon';